import React from "react";
import { Row, Col } from "react-bootstrap";
import MetricCard from "./MetricCard";

// Phase 5, §14. Form submission compliance and average eligible score —
// deliberately two SEPARATE cards, never blended into one number.
export default function FormPerformanceSummary({ formSubmission }) {
  const f = formSubmission || {};
  const compliance = f.formsWithDueDate ? (f.formsSubmittedOnTime / f.formsWithDueDate) * 100 : null;

  return (
    <Row className="g-3">
      <Col xs={6} md={3}><MetricCard label="Forms Assigned" value={f.formsAssigned} direction="INFORMATIONAL_ONLY" icon="fa-file-lines" /></Col>
      <Col xs={6} md={3}><MetricCard label="Forms Submitted" value={f.formsSubmitted} direction="HIGHER_IS_BETTER" icon="fa-circle-check" /></Col>
      <Col xs={6} md={3}>
        <MetricCard label="Submission Compliance" value={compliance} isPercentage direction="HIGHER_IS_BETTER" icon="fa-gauge-high" subtext={f.formsWithDueDate ? `${f.formsSubmittedOnTime}/${f.formsWithDueDate} on time` : "No due-dated forms"} />
      </Col>
      <Col xs={6} md={3}>
        <MetricCard
          label="Average Eligible Form Score"
          value={f.avgEligibleScore}
          isPercentage
          direction="HIGHER_IS_BETTER"
          icon="fa-star"
          insufficientData={!f.eligibleScoreCount}
          subtext={f.eligibleScoreCount ? `${f.eligibleScoreCount} finalized submission(s)` : undefined}
        />
      </Col>
    </Row>
  );
}
